import '../../i18n';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Select } from 'antd';
import { languages } from '../../constants/language';
import { Language } from '../../types/translations';

const { Option } = Select;

type LanguageSwitcherProps = {
    width?: string;
};

function LanguageSwitcher({ width = 'auto' }: LanguageSwitcherProps) {
    const { i18n } = useTranslation();

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng).then();
    };

    const mapLanguageRow = (language: Language) => {
        return (
            <Option value={language.key} key={language.key}>
                <Row align="middle" style={{ columnGap: 5 }}>
                    <img src={language.flag} alt={language.label} style={{ width: 20, marginLeft: 8 }} />
                    {language.label}
                </Row>
            </Option>
        );
    };

    return (
        <Select
            size="large"
            defaultValue={i18n.language}
            style={{ width, minWidth: '150px' }}
            onChange={changeLanguage}
        >
            {languages.map(mapLanguageRow)}
        </Select>
    );
}

export default LanguageSwitcher;
